import script from "./CommentSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentSection.vue?vue&type=script&setup=true&lang=js"

import "./CommentSection.vue?vue&type=style&index=0&id=45043546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45043546"]])

export default __exports__